module.exports = __webpack_public_path__ + "img/4.29989472.jpg";